module.exports = __webpack_public_path__ + "static/media/pepperoni.5526dbf7.jpg";